import { db } from '../firebase/config';
import { collection, addDoc, serverTimestamp, query, where, orderBy, getDocs } from 'firebase/firestore';

const COL = 'notifications';

export async function createNotification({ userId, type, title, message, data }) {
  await addDoc(collection(db, COL), {
    userId,
    type,
    title,
    message,
    data: data || {},
    read: false,
    createdAt: serverTimestamp()
  });
}

export async function listNotifications(userId, limitCount = 20) {
  const q = query(
    collection(db, COL),
    where('userId', '==', userId),
    orderBy('createdAt', 'desc')
  );
  const snap = await getDocs(q);
  return snap.docs.slice(0, limitCount).map(d => ({ id: d.id, ...d.data() }));
}

export default {
  createNotification,
  listNotifications
};
